import {AnalyseDto, DossierDto, IDossierWebServiceClient} from '@resources/resources';
import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'analyse-detail-resultat',
  templateUrl: './analyse-detail-resultat.component.html'
})
export class AnalyseDetailResultatComponent implements OnInit {

  @Input() dossier: DossierDto;
  private analysisFilters: String[] = [];

  constructor(private dossierWebService: IDossierWebServiceClient, private translateService: TranslateService) {}

  ngOnInit() {
    this.dossierWebService.getAnalysisFilters().subscribe((filters) => {
      this.analysisFilters = filters || [];
    });
  }

  getDPS(analysis: AnalyseDto) {
    const dpsExamen = analysis.dpsExamen;
    const isDpsValid = dpsExamen && new Date(dpsExamen) > new Date();

    if (this.analysisFilters.indexOf(analysis.statutExamen) == -1 && isDpsValid) {
      return this.getDateDDMMYYYY(new Date(dpsExamen));
    } else {
      return '-';
    }
  }

  getMotive(analysis: AnalyseDto) {
    if (this.analysisFilters.indexOf(analysis.statutExamen) === -1) {
      const currentDate = new Date();
      const examDate = new Date(analysis.dpsExamen);
      currentDate.setHours(0, 0, 0, 0);
      examDate.setHours(0, 0, 0, 0);

      if ( examDate < currentDate && this.analysisFilters.indexOf(analysis.dpsExamen) === -1 ) {
        return this.translateService.instant('PAGE.SERVEUR-RESULTATS.COLUMN.dpsRetard');
      } else {
        return analysis.motif;
      }
    } else {
      return "";
    }
  }

  hasInfoMissing(): Boolean {
    for (const analyse of this.dossier.analyse){
      if (analyse.libelleAnalyseT == null || analyse.nature == null || analyse.dateCreation == null || analyse.statutExamen == null || analyse.dpsExamen == null) {
        return true;
      }
    }
    return false;
  }

  getDateDDMMYYYY(date: Date): string {
    let returnDate = '';
    const dd = date.getDate();
    const mm = date.getMonth() + 1;
    const yyyy = date.getFullYear();

    if (dd < 10) {
      returnDate += `0${dd}/`;
    } else {
      returnDate += `${dd}/`;
    }
    if (mm < 10) {
      returnDate += `0${mm}/`;
    } else {
      returnDate += `${mm}/`;
    }
    returnDate += yyyy;
    return returnDate;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/body/analyse/analyse-detail-resultat.component.ts